import './App.css';
import Landing from './layout/Landing';
import Event from './layout/EventLayout';
import About from './layout/About';
import Dashboard from './dashboard/Dashboard';
import NotFound404 from './layout/NotFound';
import { Routes, Route } from "react-router";
import { ModalProvider } from './contexts/ModalContext';
import { AuthProvider } from './contexts/AuthContext';
import ModalManager from './modals/ModalManager';
import PrivateRoute from './PrivateRoute';
import PrivacyPolicy from './layout/PrivacyPolicy';
import CookiePolicy from './layout/CookiePolicy';
import TermsOfUse from './layout/TermsOfUse';
import CookieConsent from './modals/CookieConsent';
import Return from './payfast/Return';
import Cancel from './payfast/Cancel';
import NewroConnectLanding from './newroconnect/LandingPage';
import ProfilePage from "./newroconnect/pages/ProfilePage";
import TrainerConsole from './newroconnect/pages/TrainerConsole';
import usePageTracking from './firebase/usePageTracking';
import CourseEditor from './newroconnect/pages/CourseEditor';
import CoursePage from './newroconnect/pages/CoursePage';
import Happea from './afm/pages/Happea';

function App() {
  usePageTracking();
  return (
    <AuthProvider>
      <ModalProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="about" element={<About />} />
          <Route path="event/:eventId" element={<Event />} />
          {/* Newro connect routes */}
          <Route path="connect" element={<NewroConnectLanding />} />
          <Route path="/connect/profile/:personId" element={<ProfilePage />} />
          <Route
            path="/connect/console/:personId"
            element={
              <PrivateRoute >
                <TrainerConsole />
              </PrivateRoute>
            }
          />
          <Route
            path="/connect/console/:personId/course/new"
            element={
              <PrivateRoute >
                <CourseEditor />
              </PrivateRoute>
            }
          />
          <Route
            path="/connect/console/:personId/course/:courseId"
            element={
              <PrivateRoute >
                <CourseEditor />
              </PrivateRoute>
            }
          />
          <Route path="/connect/course/:trainerId/:courseId" element={<CoursePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/return" element={<Return />} />
          <Route path="/cancel" element={<Cancel />} />
          {/* Admin Console route */}
          <Route
            path="dashboard"
            element={
              <PrivateRoute allowedRoles={["admin"]}>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<NotFound404 />} />
          <Route path="/afm/happea" element={<Happea />} />

        </Routes>
        <ModalManager />
        <CookieConsent />
      </ModalProvider>
    </AuthProvider>
  );
}

export default App;
